<div class="rad-app">
  <!-- Mobile backdrop -->
  <div
    class="sidebar-backdrop"
    [class.visible]="isMobileMenuOpen"
    (click)="closeMobileMenu()"
    aria-hidden="true">
  </div>

  <!-- Sidebar -->
  <nav
    class="rad-sidebar"
    [class.rad-sidebar--collapsed]="isSidebarCollapsed && !isMobileMenuOpen"
    [class.rad-sidebar--mobile-open]="isMobileMenuOpen"
    aria-label="Main navigation">

    <!-- Logo section -->
    <div
      class="rad-sidebar__logo"
      (click)="go('/userhome')"
      role="button"
      tabindex="0"
      (keydown.enter)="go('/userhome')"
      (keydown.space)="$event.preventDefault(); go('/userhome')">
      <img
        *ngIf="!isSidebarCollapsed || isMobileMenuOpen"
        src="assets/logo.png"
        alt="Radio Ads Direct"
        class="rad-sidebar__logo-full"
        (error)="onLogoError($event)">
      <div
        *ngIf="isSidebarCollapsed && !isMobileMenuOpen"
        class="rad-sidebar__logo-icon">
        RAD
      </div>
    </div>

    <!-- Collapse toggle -->
    <button
      type="button"
      class="rad-sidebar__toggle"
      (click)="toggleSidebar()"
      [attr.aria-label]="isSidebarCollapsed ? 'Expand menu' : 'Collapse menu'">
      <svg width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor"
        stroke-width="2.5" stroke-linecap="round" aria-hidden="true">
        <ng-container *ngIf="!isSidebarCollapsed">
          <polyline points="15 18 9 12 15 6"></polyline>
        </ng-container>
        <ng-container *ngIf="isSidebarCollapsed">
          <polyline points="9 18 15 12 9 6"></polyline>
        </ng-container>
      </svg>
    </button>

    <!-- Nav items -->
    <div id="app-main-nav" class="rad-sidebar__nav">
      @if (navReady()) {
        <ng-container *ngFor="let item of visibleItems">
          @if (item.label === 'Stations') {
            <div class="rad-nav-divider">
              <span class="rad-nav-divider__label" *ngIf="!isSidebarCollapsed || isMobileMenuOpen">Station</span>
            </div>
          }
          @if (item.label === 'Owners') {
            <div class="rad-nav-divider">
              <span class="rad-nav-divider__label" *ngIf="!isSidebarCollapsed || isMobileMenuOpen">Administration</span>
            </div>
          }
          @if (item.label === 'My Offers') {
            <div class="rad-nav-divider">
              <span class="rad-nav-divider__label" *ngIf="!isSidebarCollapsed || isMobileMenuOpen">Offers</span>
            </div>
          }
          @if (item.label === 'Help' || item.label === 'Raise a Ticket') {
            <div class="rad-nav-divider">
              <span class="rad-nav-divider__label" *ngIf="!isSidebarCollapsed || isMobileMenuOpen">Help</span>
            </div>
          }

          <a
            class="rad-nav-item"
            [routerLink]="item.route"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: item.route === '/help' }"
            [matTooltip]="item.label"
            matTooltipPosition="right"
            matTooltipClass="rad-nav-tooltip"
            [matTooltipShowDelay]="300"
            [matTooltipDisabled]="!isSidebarCollapsed || isMobileMenuOpen"
            [attr.aria-label]="item.label"
            (click)="closeMobileMenu()">
            <span class="rad-nav-item__icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round">
                @switch (item.label) {
                  @case ('Home') {
                    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"></path>
                    <polyline points="9 22 9 12 15 12 15 22"></polyline>
                  }
                  @case ('Orders') {
                    <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2"></path>
                    <rect x="9" y="3" width="6" height="4" rx="2" ry="2"></rect>
                  }
                  @case ('Commercial Requests') {
                    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"></path>
                  }
                  @case ('Recordings') {
                    <circle cx="12" cy="12" r="10"></circle>
                    <circle cx="12" cy="12" r="3"></circle>
                  }
                  @case ('Stations') {
                    <path d="M2 16.1A5 5 0 015.9 20M2 12.05A9 9 0 019.95 20M2 8V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6"></path>
                    <line x1="2" y1="20" x2="22" y2="20"></line>
                  }
                  @case ('Station Clocks') {
                    <circle cx="12" cy="12" r="10"></circle>
                    <polyline points="12 6 12 12 16 14"></polyline>
                  }
                  @case ('Ratings') {
                    <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>
                  }
                  @case ('Station Rates') {
                    <line x1="12" y1="1" x2="12" y2="23"></line>
                    <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"></path>
                  }
                  @case ('Billing & Analytics') {
                    <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                    <line x1="8" y1="21" x2="16" y2="21"></line>
                    <line x1="12" y1="17" x2="12" y2="21"></line>
                  }
                  @case ('Owners') {
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <path d="M23 21v-2a4 4 0 00-3-3.87"></path>
                    <path d="M16 3.13a4 4 0 010 7.75"></path>
                  }
                  @case ('Staff Directory') {
                    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"></path>
                    <circle cx="9" cy="7" r="4"></circle>
                    <line x1="23" y1="11" x2="17" y2="11"></line>
                    <line x1="20" y1="8" x2="20" y2="14"></line>
                  }
                  @case ('User Analytics') {
                    <line x1="18" y1="20" x2="18" y2="10"></line>
                    <line x1="12" y1="20" x2="12" y2="4"></line>
                    <line x1="6" y1="20" x2="6" y2="14"></line>
                  }
                  @case ('My Offers') {
                    <rect x="3" y="8" width="18" height="13" rx="2"></rect>
                    <path d="M12 8v13M3 12h18M7.5 8C5 8 5 4 7.5 4 10 4 12 8 12 8s2-4 4.5-4S19 8 16.5 8"></path>
                  }
                  @case ('Help') {
                    <circle cx="12" cy="12" r="10"></circle>
                    <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"></path>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                  }
                  @case ('Raise a Ticket') {
                    <path d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"></path>
                  }
                  @case ('Support Inbox') {
                    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline>
                    <path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"></path>
                  }
                }
              </svg>
            </span>
            <span class="rad-nav-item__label">{{ item.label }}</span>
            <span class="rad-nav-item__tooltip">{{ item.label }}</span>
          </a>
        </ng-container>
      } @else {
        <div class="nav-loading" role="status" aria-live="polite">
          <span class="nav-loading-bar"></span>
          <span class="nav-loading-bar"></span>
          <span class="nav-loading-bar"></span>
        </div>
      }
    </div>
  </nav>

  <!-- Mobile hamburger -->
  <button class="rad-mobile-toggle" type="button"
    (click)="openMobileMenu()" aria-label="Open menu">
    <svg width="20" height="20" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  </button>

  <div class="main rad-main-content"
    [class.rad-main-content--shifted]="isSidebarCollapsed">
    <header class="topbar">
      <div class="left"></div>
      <div class="right topbar-actions">
        @if (canManagePromoCodes) {
          <div class="promo-codes-icon-wrap">
            <button
              mat-icon-button
              type="button"
              class="icon-btn ghost promo-codes-icon-btn"
              routerLink="/promo-codes"
              routerLinkActive="active"
              aria-label="Open promo codes">
              <mat-icon>local_offer</mat-icon>
            </button>
            <div class="promo-codes-tag" role="tooltip">Promo codes</div>
          </div>
        }
        <div class="cart-icon-wrap">
          <button
            mat-icon-button
            type="button"
            class="icon-btn ghost"
            routerLink="/cart"
            [attr.aria-label]="cartCount() > 0 ? 'Open cart, ' + cartCount() + ' items' : 'Open cart'">
            <mat-icon>shopping_cart</mat-icon>
            @if (cartCount() > 0) {
              <span class="cart-badge">{{ cartCount() > 99 ? '99+' : cartCount() }}</span>
            }
          </button>
        </div>
        <div class="profile-icon-wrap">
          <button
            mat-icon-button
            type="button"
            class="icon-btn ghost"
            routerLink="/profile"
            aria-label="Open profile">
            <mat-icon>account_circle</mat-icon>
          </button>
          @if (userEmail()) {
            <div class="profile-email-pop" role="tooltip" [attr.title]="userEmail()">{{ userEmail() }}</div>
          }
        </div>
        <div class="notification-bell-wrap">
          <button mat-icon-button class="icon-btn ghost" (click)="toggleNotificationDropdown()" aria-label="Notifications">
            <mat-icon>notifications</mat-icon>
            @if (unreadCount() > 0) {
              <span class="notification-badge">{{ unreadCount() > 99 ? '99+' : unreadCount() }}</span>
            }
          </button>
          @if (notificationDropdownOpen()) {
            <div class="notification-dropdown" role="dialog" aria-label="Notifications">
              <header class="notification-dropdown-header">
                <div class="notification-heading">
                  <span class="notification-heading-icon">
                    <mat-icon aria-hidden="true">notifications_none</mat-icon>
                  </span>
                  <div>
                    <h2>Notifications</h2>
                    <p>{{ unreadCount() }} unread</p>
                  </div>
                </div>
                <div class="notification-header-actions">
                  <button
                    type="button"
                    class="notification-mark-all"
                    (click)="markAllNotificationsRead()"
                    [disabled]="unreadCount() === 0">
                    Mark all read
                  </button>
                  <button
                    type="button"
                    class="notification-close"
                    (click)="closeNotificationDropdown()"
                    aria-label="Close notifications">
                    <mat-icon aria-hidden="true">close</mat-icon>
                  </button>
                </div>
              </header>

              <div class="notification-list">
                @if (notificationsLoading()) {
                  <div class="notification-skeleton">
                    @for (s of [1,2,3,4]; track s) {
                      <div class="notification-skeleton-row">
                        <span class="skeleton-avatar"></span>
                        <span class="skeleton-copy">
                          <span class="skeleton-line title"></span>
                          <span class="skeleton-line message"></span>
                          <span class="skeleton-line time"></span>
                        </span>
                      </div>
                    }
                  </div>
                } @else if (notifications().length === 0) {
                  <div class="notification-empty">
                    <span class="notification-empty-icon">
                      <mat-icon aria-hidden="true">notifications_off</mat-icon>
                    </span>
                    <h3>You’re all caught up</h3>
                    <p>New updates will appear here.</p>
                  </div>
                } @else {
                  @for (n of notifications(); track n.id) {
                    <article class="notification-item" [class.unread]="!n.is_read">
                      <span class="notification-status-dot" *ngIf="!n.is_read" aria-label="Unread"></span>
                      <span class="notification-type-icon">
                        <mat-icon aria-hidden="true">{{ notificationIcon(n) }}</mat-icon>
                      </span>

                      <button
                        type="button"
                        class="notification-content"
                        (click)="onNotificationClick(n)">
                        <span class="notification-item-topline">
                          <strong class="notification-title">{{ n.title }}</strong>
                          <time class="notification-time">{{ timeAgo(n.created_at) }}</time>
                        </span>
                        <span class="notification-message">{{ n.message }}</span>
                        @if (notificationActionLabel(n)) {
                          <span class="notification-action">
                            {{ notificationActionLabel(n) }}
                            <mat-icon aria-hidden="true">arrow_forward</mat-icon>
                          </span>
                        }
                      </button>

                      <div class="notification-item-actions">
                        <button
                          type="button"
                          class="notification-item-action"
                          (click)="snoozeNotification(n, $event)"
                          title="Snooze for 1 hour"
                          aria-label="Snooze notification for 1 hour">
                          <mat-icon aria-hidden="true">schedule</mat-icon>
                        </button>
                        <button
                          type="button"
                          class="notification-item-action notification-item-action--dismiss"
                          (click)="dismissNotification(n, $event)"
                          title="Dismiss"
                          aria-label="Dismiss notification">
                          <mat-icon aria-hidden="true">close</mat-icon>
                        </button>
                      </div>
                    </article>
                  }
                }
              </div>

              <footer class="notification-footer">
                <mat-icon aria-hidden="true">schedule</mat-icon>
                Snoozed notifications return after one hour.
              </footer>
            </div>
          }
        </div>
        <button
          mat-icon-button
          class="icon-btn ghost theme-toggle"
          type="button"
          (click)="theme.toggle()"
          [attr.aria-label]="theme.colorMode() === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'">
          <mat-icon>{{ theme.colorMode() === 'dark' ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>
        <button type="button" class="btn-primary logout-btn" (click)="confirmLogout()">
          <mat-icon aria-hidden="true">logout</mat-icon>
          <span class="hide-sm">Logout</span>
        </button>
      </div>
    </header>

    <main class="content">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
